import { inject, Injectable } from "@angular/core";
import { DustExZoneType } from "@domain/project/floorplan/zones/dust-ex-zone";
import { ExZoneType } from "@domain/project/floorplan/zones/ex-zone";
import { WildcardZoneType } from "@domain/project/floorplan/zones/wildcard-zone";
import { FloorplanService } from "@project/floorplanner/floorplan.service";

@Injectable()
export class FloorplanZonesService {
  private floorplanService = inject(FloorplanService);

  addExZone(type: ExZoneType) {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addExZone(type, x, y),
      this.floorplanService.selectedFloorplan.exZones,
    );
  }

  addDustExZone(type: DustExZoneType) {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addDustExZone(type, x, y),
      this.floorplanService.selectedFloorplan.dustExZones,
    );
  }

  addWildcardZone(type: WildcardZoneType) {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addWildcardZone(type, x, y),
      this.floorplanService.selectedFloorplan.wildcardZones,
    );
  }

  addDangerArea() {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addDangerArea(x, y),
      this.floorplanService.selectedFloorplan.dangerAreas,
    );
  }

  addIsolationRoom() {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addIsolationRoom(x, y),
      this.floorplanService.selectedFloorplan.isolationRooms,
    );
  }

  addItRoom() {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addItRoom(x, y),
      this.floorplanService.selectedFloorplan.itRooms,
    );
  }
  addOperatingTheatre() {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addOperatingTheatre(x, y),
      this.floorplanService.selectedFloorplan.operatingTheatres,
    );
  }
  addProcedureRoom() {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addProcedureRoom(x, y),
      this.floorplanService.selectedFloorplan.procedureRooms,
    );
  }
  addStandardRoom() {
    this.floorplanService.addItem(
      (x, y) => this.floorplanService.selectedFloorplan.addStandardRoom(x, y),
      this.floorplanService.selectedFloorplan.standardRooms,
    );
  }
}
